import React, { useState, useRef, useEffect } from 'react';
import { Col, Row, Button } from 'react-bootstrap';
import DualCoverage from 'src/shared/Registration/DualCoverage/DualCoverage';
import GenericButton from 'src/Components/GenericButton/GenericButton';
import { useDispatch, useSelector } from 'react-redux';
import APIEndpoints from 'src/Admin/api/APIEndpoints';
import { axiosInstance } from 'src/api/axios';
import { HttpSuccessCodes } from 'src/Admin/errorhandling/HttpErrorCodes';
import { toast } from 'react-toastify';
import ToastMessage from '../common/ToastMessage';
import { deleteDataOfEmail } from 'src/redux/admin/membersSlice';

const AffiliateCoverage = (props) => {
  const userDataRedux = props.userDataRedux;
  const dispatch = useDispatch();

  const isSelectedCoverage = props?.data.every((d) => d.isSelected !== true);
  const selectedCoverage = props?.data.filter((d) => d.isSelected === true);
  const [approvalNeeded, setApprovalNeeded] = useState(false);

  const getAdminConfig = async () => {
    try {
      const responseConfiguration = await axiosInstance.get(
        APIEndpoints.getAdminConfigResources(),
      );
      const adminConfig = responseConfiguration.data;
      setApprovalNeeded(
        adminConfig?.Response?.InsurerClientSettings
          ?.DualCoverageApproveSelfAffiliation,
      );
    } catch (err) {
      console.log('err', err);
    }
  };

  useEffect(() => {
    getAdminConfig();
  }, []);

  //api integration on submit button for save userDetails

  const handleSubmit = async () => {
    const dualCoverageArray = [];
    //userDataRedux?.MemberDetailsList?.map((item) =>
    //dualCoverageArray.push({
    //MemberOid: item?.MemberOID,
    //DefaultProfile: item?.DefaultProfile,
    //}),
    //);
    selectedCoverage?.map((item) =>
      dualCoverageArray.push({
        //MemberOid: item?.oid,
        [item?.userType === 'Dependent' ? 'DependentOid' : 'MemberOid']:
          item?.oid,
        DefaultProfile: false,
      }),
    );

    const createPayload = (isApprovalNeeded) => {
      if (isApprovalNeeded) {
        return {
          DualCoverageAddUser: {
            UserType: 'multimember',
            UserID: userDataRedux?.UserID,
            FirstName: userDataRedux?.FirstName || userDataRedux?.firstName,
            MiddleName: userDataRedux?.MiddleName || userDataRedux?.middleName,
            LastName: userDataRedux?.LastName || userDataRedux?.lastName,
            Status: 'Pending Approval',
            SubCategory: 'Self Affiliation',
            DualCoverageAffiliation: dualCoverageArray,
            RRUserOID: userDataRedux?.Oid,
          },
        };
      }
      return {
        UpdateUser: {
          Oid: userDataRedux?.Oid,
          UserType: 'multimember',
          UserID: userDataRedux?.UserID,
          FirstName: userDataRedux?.FirstName || userDataRedux?.firstName,
          MiddleName: userDataRedux?.MiddleName || userDataRedux?.middleName,
          LastName: userDataRedux?.LastName || userDataRedux?.lastName,
          Status: userDataRedux?.Status,
          MappedEnties: dualCoverageArray,
        },
      };
    };

    const handleApiResponse = (
      response,
      successMessage,
      errorMessage,
      callback,
    ) => {
      if (
        response?.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_201 ||
        response?.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200
      ) {
        toast.success(
          <ToastMessage
            type="success"
            title={successMessage}
            //subTitle="Contact your Plan Administrator for further queries."
          />,
        );
        setTimeout(callback, 1000);
      } else {
        console.error('API Response Error:', response);
        toast.error(
          <ToastMessage
            type="error"
            title={errorMessage}
            subTitle="Contact your Plan Administrator for further queries."
          />,
        );
      }
    };

    try {
      const payload = createPayload(approvalNeeded);
      const apiCall = approvalNeeded
        ? axiosInstance.post(
            APIEndpoints.dualCoverageUpdateUserSelfAffiliationResources(),
            payload,
          )
        : axiosInstance.put(
            APIEndpoints.UpdateUserResourceWithoutApproval(),
            payload,
          );
      //axiosInstance.put(APIEndpoints.UpdateUserResource(), payload);

      const response = await apiCall;
      console.log('API Response Data:', response?.data);

      const successMessage = approvalNeeded
        ? 'You will receive a notification within 24 to 48 business hours on the status of your request.'
        : 'Member can login and will have the ability to select any one record and access the details of the selected record.';
      const errorMessage = approvalNeeded
        ? 'Your request has not been successfully submitted for review.'
        : 'Your request to affiliate your account could not be submitted. Try again later';

      handleApiResponse(response, successMessage, errorMessage, () => {
        if (approvalNeeded) {
          props?.backHandler(true);
        } else {
          props?.backHandler(true); //Reset state
          dispatch(deleteDataOfEmail({ email: userDataRedux?.UserID }));
        }
      });
    } catch (error) {
      console.error('API Call Error:', error);
      const errorMessage = approvalNeeded
        ? 'Your request has not been successfully submitted for review.'
        : 'Your request has not been successfully submitted for the affiliate account.';
      toast.error(
        <ToastMessage
          type="error"
          title={errorMessage}
          subTitle="Contact your Plan Administrator for further queries."
        />,
      );
    }
  };

  return (
    <div>
      <div className="pt-3">
        We have found a record(s). Select the record(s) that you want to link to
        your account.
      </div>
      <Row className="pt-4">
        <Col md={12} xs={12} lg={12} sm={12}>
          {props.data &&
            props.data.map((item) => (
              <DualCoverage
                key={item.oid}
                item={item}
                onSelectHandler={props?.onSelectHandler}
                onDualCoverageRadioChange={props?.onDualCoverageRadioChange}
                selectedDualCoverageOption={props?.selectedDualCoverageOption}
                multiSelect={props.multiSelect}
              />
            ))}
        </Col>
      </Row>
      <div className="d-flex justify-content-center mr-5">
        <GenericButton
          className="coverageInfo m-0"
          onClick={() => {
            handleSubmit();
          }}
          variant="primary"
          disable={
            props.multiSelect
              ? isSelectedCoverage
              : props?.selectedDualCoverageOption === null
          }
          buttonDisabled={
            props.multiSelect
              ? isSelectedCoverage
              : props?.selectedDualCoverageOption === null
          }
        >
          SUBMIT
        </GenericButton>
      </div>
    </div>
  );
};

export default AffiliateCoverage;
